import {createFileRoute, redirect} from '@tanstack/react-router'

/** Legacy short-prefix URL → /live/leagues/{slug-or-uid}. */
export const Route = createFileRoute('/live/l/$league_uid')({
    beforeLoad: ({params}) => {
        throw redirect({to: `/live/leagues/${params.league_uid}`} as any)
    },
})
